import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

import moment from "moment";

import "moment/locale/ar";
import "moment/locale/fr";
import "moment/locale/en-gb";

import resources from "./locales";

i18n.on("languageChanged", () => {
	moment.locale(i18n.language);

	// Set direction to RTL for certain language(s)
	i18n.language === "ar" || i18n.language === "he"
		? document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
		: document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
})
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		resources,
		fallbackLng: ["en", "en-gb", "fr", "ar"],
		// debug: true,
		whitelist: ["en", "en-gb", "fr", "ar"],
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		lowerCaseLng: true,
	});

export default i18n;
